import { WidgetEntity } from './WidgetEntity';

export abstract class BaseWidgetEntityWithWellId extends WidgetEntity {
  abstract get wellId(): number | null;
  abstract setWellId(wellId: number | null): void;
}
